// Copia local (localStorage) de la ÚLTIMA respuesta completa del dashboard "INDICADORES", usada SOLO
// en la carga inicial (al entrar al dashboard después del login): si existe, se pintan al instante los
// KPIs/gráficas de esa copia (con el aviso "Actualizando información" junto al título) mientras el backend responde con los
// datos frescos; si no existe (primera vez), la carga es la de siempre, con BrandedLoader a pantalla
// completa. El botón "Actualizar", los filtros y todo lo demás siguen igual — solo ESCRIBEN aquí.
//
// UNA sola llave y UNA sola copia (la última consulta, de quien sea): cada guardado reemplaza la anterior,
// así el localStorage nunca crece por cambiar de rango de fechas ni de usuario. La copia guarda con qué
// usuario y rango se hizo y solo se usa si coinciden con los de la carga actual (los datos y los permisos
// dependen de ambos): la de otro usuario o de otro rango se ignora (y se sobrescribe al guardar la nueva).
// Sobrevive al logout a propósito (si no, al volver a entrar nunca habría copia que mostrar):
// util/sessionStorageCleanup.js preserva esta llave — si cambia CACHE_KEY hay que actualizar también esa lista.
export const CACHE_KEY = 'dashboard_sale_indicators_cache'

function currentUserId() {
    try {
        const user = JSON.parse(localStorage.getItem('user'))
        return (user && user.id) ? user.id : 'anon'
    } catch (e) {
        return 'anon'
    }
}

function rangeOf(params) {
    const [from, to] = (params && params.date) || []
    return `${from}_${to}`
}

// Devuelve el dashboard guardado si es de este usuario y rango; null si no hay copia, es de otro
// usuario/rango, el JSON está corrupto o el storage no está disponible.
export function loadCachedDashboard(params) {
    try {
        const raw = localStorage.getItem(CACHE_KEY)

        if (!raw) {
            return null
        }

        const entry = JSON.parse(raw)

        if (!entry || String(entry.userId) !== String(currentUserId()) || entry.range !== rangeOf(params)) {
            return null
        }

        const dashboard = entry.dashboard

        // Forma mínima esperada de la respuesta del endpoint: { period, kpis, charts }.
        return (dashboard && dashboard.kpis && dashboard.charts && dashboard.period) ? dashboard : null
    } catch (e) {
        return null
    }
}

export function saveCachedDashboard(params, dashboard) {
    try {
        localStorage.setItem(CACHE_KEY, JSON.stringify({
            userId: currentUserId(),
            range: rangeOf(params),
            dashboard
        }))
    } catch (e) {
        // Storage lleno/no disponible: no es crítico, la próxima carga simplemente no tendrá copia.
    }
}



// WEBPACK FOOTER //
// ./src/components/dashboard-sale-indicators/dashboardCache.js